import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  deleteAreaPlanService,
  getAreaPlanningSignedUrlService,
  getAreaPlansService,
  getProjectAreaplansService,
  putPdfFileToS3Service,
  saveAreaplanService,
  updateAreaplanService,
} from '../services/areaPlanServices';
import { getSelectedAreaPlan } from '../slices/areaPlanningSlice';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const getAreaPlansThunk = createAsyncThunk(
  'areaplanning/getAreaplans',
  async (payload, { getState, rejectWithValue }) => {
    const state = getState();
    const selectedProjectId = selectSelectedProjectId(state);

    try {
      const response = await getAreaPlansService(selectedProjectId);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW UNIT data');
    }
  }
);

export const saveAreaplanThunk = createAsyncThunk(
  'areaplanning/saveAreaplan',
  async (
    { areaplanDraft, fileId, fileBinary },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState();
      const selectedProjectId = selectSelectedProjectId(state);

      // GET SIGNED URL
      console.log('got signed url');

      // UPLOAD FILE
      const { signedUrl, key } = await getAreaPlanningSignedUrlService(
        fileId,
        selectedProjectId
      );

      await putPdfFileToS3Service(signedUrl, fileBinary);
      console.log('uploaded to s3');

      // SAVE TO DB
      console.log('KEY', key);
      const response = await saveAreaplanService(areaplanDraft, key);

      console.log('saved to dynamodb');

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW');
    }
  }
);

export const saveNewAreaplanVersionThunk = createAsyncThunk(
  'areaplanning/saveNewAreaplanVersionThunk',
  async ({ areaplanDraft }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const selectedProjectId = selectSelectedProjectId(state);
      const { key, ...newAreaplanVersion } = areaplanDraft;

      const response = await saveAreaplanService(
        newAreaplanVersion,
        key,
        selectedProjectId
      );

      return response;
    } catch (error) {
      return rejectWithValue('Failed to add NEW');
    }
  }
);

export const updateAreaPlanThunk = createAsyncThunk(
  'areaplanning/updateAreaplan',
  async ({ areaplan }, { getState, rejectWithValue }) => {
    console.log('updateAreaplanThunk');
    try {
      const state = getState();
      const selectedProjectId = selectSelectedProjectId(state);
      const selectedPlan = getSelectedAreaPlan(state);
      const modifiedPlan = {
        ...selectedPlan,
        ...areaplan,
      };

      const response = await updateAreaplanService(
        modifiedPlan,
        selectedProjectId
      );
      return response;
    } catch (error) {
      return rejectWithValue('Failed to update');
    }
  }
);

export const deleteAreaPlanThunk = createAsyncThunk(
  'areaplanning/deleteAreaplan',
  async ({ areaplan }, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const selectedProjectId = selectSelectedProjectId(state);

      const response = await deleteAreaPlanService(areaplan, selectedProjectId);
      return response;
    } catch (error) {
      return rejectWithValue('Failed to delete');
    }
  }
);

export const getProjectAreaplansThunk = createAsyncThunk(
  'areaplanning/getProjectAreaplans',
  async ({ projectId }, { rejectWithValue }) => {
    try {
      const response = await getProjectAreaplansService(projectId);

      return response;
    } catch (error) {
      return rejectWithValue('Failed to get plans with project id');
    }
  }
);
